import { notifyError } from './notifyError';

let installed = false;
const RESIZE_OBSERVER_LOOP_MSG = 'ResizeObserver loop completed with undelivered notifications.';

export function installGlobalErrorHandlers() {
  if (installed) return;
  installed = true;

  // Ignore a known browser warning frequently emitted during rapid React Flow layout updates.
  // In dev, this can be surfaced by the overlay as a runtime error even though it is non-fatal.
  const isResizeObserverLoopWarning = (message) =>
    typeof message === 'string' &&
    (message.includes(RESIZE_OBSERVER_LOOP_MSG) ||
      message.includes('ResizeObserver loop limit exceeded'));

  const suppressResizeObserverLoopError = (event) => {
    try {
      const message = event?.message || event?.error?.message || '';
      if (isResizeObserverLoopWarning(message)) {
        event.preventDefault?.();
        event.stopImmediatePropagation?.();
        return true;
      }
      return false;
    } catch {
      return false;
    }
  };

  window.addEventListener('error', suppressResizeObserverLoopError, true);

  const previousOnError = window.onerror;
  window.onerror = function patchedWindowOnError(message, source, lineno, colno, error) {
    if (isResizeObserverLoopWarning(String(message || error?.message || ''))) {
      return true;
    }
    if (typeof previousOnError === 'function') {
      return previousOnError.call(window, message, source, lineno, colno, error);
    }
    return false;
  };

  // Keep this conservative: only show a toast for actual Error objects.
  // Many libs reject with non-Error values; those can get noisy fast.
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event && event.reason;
      if (typeof reason === 'string' && reason.includes(RESIZE_OBSERVER_LOOP_MSG)) {
        return;
      }
      if (
        reason &&
        typeof reason?.message === 'string' &&
        reason.message.includes(RESIZE_OBSERVER_LOOP_MSG)
      ) {
        return;
      }
      if (reason instanceof Error) {
        notifyError(reason, { toastId: 'global.unhandledrejection' });
      }
    } catch {
      // ignore
    }
  });
}

